import cx from 'classnames'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { primaryLinks } from '../../../content/menu'
import { PageContext } from '../../../context/PageContext'
import Badge from '../Badge'
import MenuIcon from '../MenuIcon'
import PageLink from '../PageLink'
import './styles.scss'

const MainMenu = ({ location, lang }) => {
  const { showMenu } = useContext(PageContext)

  return (
    <nav className="main-menu">
      <ul className="main-menu__list">
        {primaryLinks.map((link, index) => (
          <li
            className={cx({
              'main-menu__list__item': true,
              'main-menu__list__item--hideOnMobile': true,
              'is-hidden': !showMenu
            })}
            key={index}
          >
            <PageLink to={link[lang].to} active={location.pathname === link[lang].to ? true : false}>
              {link[lang].name}
              {link.badge && (
                <Badge
                  text={link.badge.text}
                  variant="neutral"
                  top={link.badge.top}
                  right={link.badge.right}
                  bottom={link.badge.bottom}
                  left={link.badge.left}
                  connectorPosition="right"
                  connectorDirection="top"
                />
              )}
            </PageLink>
          </li>
        ))}
        <li className="main-menu__list__item">
          <MenuIcon />
        </li>
      </ul>
    </nav>
  )
}

MainMenu.propTypes = {
  location: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired
}

export default MainMenu
